import PlateShow from '@/common/components/base/plateShow/PlateShow';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import convertTimeStampToDate from '@/common/utils/convertTimeStampToDate';
import { DamagesInformationQuery } from '@/modules/FileDetail/queries/damagesInformation/damagesInformationQuery.type.ts';

export default (data: DamagesInformationQuery): DetailCardItemData[] => {
  return [
    {
      type: 'default',
      keyName: 'نام',
      value:
        data.first_name || data.last_name
          ? ` ${data.first_name ?? ''} ${data.last_name ?? ''}`
          : '',
    },
    {
      type: 'tel',
      keyName: 'تلفن همراه',
      value: data?.phone_number,
      telephone: data?.phone_number,
    },
    {
      type: 'default',
      keyName: 'نوع وسیله‌نقلیه',
      value: data.vehicle_type?.fa_const,
    },

    {
      type: 'default',
      keyName: 'سیستم و تیپ خودرو ',
      value: data.vehicle_model,
    },
    {
      type: 'default',
      keyName: 'طرح پلاک',
      value: data.vehicle_plate_design?.fa_const,
    },
    {
      type: 'default',
      keyName: 'پلاک',
      value: data?.vehicle_plate ? (
        <PlateShow
          plateData={{
            vehicle_plate: data?.vehicle_plate,
            vehicle_plate_bottom: data?.vehicle_plate_bottom,
            vehicle_plate_iran: data?.vehicle_plate_iran,
            vehicle_plate_left: data?.vehicle_plate_left,
            vehicle_plate_letter: data?.vehicle_plate_letter,
            vehicle_plate_right: data?.vehicle_plate_right,
            vehicle_plate_top: data?.vehicle_plate_top,
          }}
          vehicleDesign={data?.vehicle_plate_design?.const}
          vehicleType={data.vehicle_type?.const!}
        />
      ) : null,
    },
    {
      type: 'default',
      keyName: 'زمان بازدید',
      value:
        data.visit_date && data.visit_time
          ? `${data.visit_time} - ${convertTimeStampToDate(
              Number(data?.visit_date),
              {
                hour: undefined,
                minute: undefined,
              },
            )} `
          : '',
    },
    {
      type: 'default',
      keyName: 'آدرس بازدید',
      value: data.visit_location
        ? `${data.visit_location}   ${data.visit_location_detail ? `، ${data.visit_location_detail}` : ''}`
        : '',
    },
  ];
};
